import { render } from "./m-edit-officer.vue?vue&type=template&id=687c513e&scoped=true"
import script from "./m-edit-officer.vue?vue&type=script&lang=js"
export * from "./m-edit-officer.vue?vue&type=script&lang=js"

import "./m-edit-officer.vue?vue&type=style&index=0&id=687c513e&scoped=true&lang=scss"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687c513e"]])

export default __exports__